import { asLooseNode } from './asLooseNode';

/**
 * Extracts a plain-text representation of an ADF DocNode by walking its text nodes.
 * Used as the text/plain clipboard payload when content is already structured ADF.
 */
export const adfNodeToPlain = (node: unknown): string => {
	const n = asLooseNode(node);

	if (n.type === 'text') {
		return n.text ?? '';
	}
	if (n.type === 'hardBreak') {
		return '\n';
	}
	if (n.type === 'mention') {
		// Fall back to the id when the mention label is still unresolved.
		const mentionText = n.attrs?.text;
		const hasName = typeof mentionText === 'string' && mentionText !== '@' && mentionText !== '';
		return hasName ? mentionText : `@${n.attrs?.id ?? ''}`;
	}
	if (n.type === 'inlineCard' || n.type === 'blockCard' || n.type === 'embedCard') {
		const url = n.attrs?.url;
		return typeof url === 'string' ? url : '';
	}

	// Block nodes — separate with newlines for readability. `listItem` is
	// intentionally omitted: its child (typically a paragraph) already supplies
	// a trailing '\n', so re-adding one here yields a blank line per bullet.
	const childText = Array.isArray(n.content) ? n.content.map(adfNodeToPlain).join('') : '';
	if (
		n.type === 'paragraph' ||
		n.type === 'heading' ||
		n.type === 'bulletList' ||
		n.type === 'orderedList' ||
		n.type === 'codeBlock'
	) {
		return childText + '\n';
	}
	return childText;
};
